export const tableHeaders = ({ isLabelsEnabled }) => [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id',
    sortableId: 'id'
  },
  {
    id: 2,
    label: 'First Name',
    intlKey: 'table.first_name',
    sortableId: 'participant.firstName'
  },
  {
    id: 3,
    label: 'Last Name',
    intlKey: 'table.last_name',
    sortableId: 'participant.lastName'
  },
  {
    id: 4,
    label: 'Registration Approved',
    intlKey: 'table.registration_approved',
    sortableId: 'registrationDate'
  },
  {
    id: 5,
    label: 'Level',
    intlKey: 'table.level',
    sortable: false
  },
  {
    id: 6,
    label: 'Status',
    intlKey: 'table.status',
    sortable: false
  },
  {
    id: 7,
    label: 'Award leader',
    intlKey: 'table.award_leader',
    sortable: false
  },
  {
    id: 8,
    label: 'Participant Labels',
    intlKey: 'table.labels',
    sortable: false,
    hide: !isLabelsEnabled
  },
]
